import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { API_URL } from "../../../../../constants";
import moment from "moment";
import RatingComponent from "../../../../../components/RatingComponent";
import RatingComponentWithoutNa from "../../../../../components/RatingComponentWithoutNA";
import { GetServiceCaller } from "../../../../../services/serviceCaller";
import DropdownValue from "../../../../../components/DropdownValue";
import HTMLComponent from "../../../../../components/HtmlComponent";

const LeadCreated = ({ leadData }) => {
  const [leadCandidateStatus, setLeadCandidateStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  
  useEffect(() => {
    fetchDetails();
  }, [leadData.LeadCandidateStatus_189, leadData]);
  function fetchDetails() {GetServiceCaller(API_URL + "newapplication")
      .then((response) => {
        if (response.data && response?.data?.data?.LeadCandidateStatus) {
          setLeadCandidateStatus(response?.data?.data?.LeadCandidateStatus);
          setSelectedStatus(leadData.LeadCandidateStatus_189);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }
  // function fetchDetails() {
  //   GetServiceCaller(API_URL + "newapplication")
  //     .then((response) => {
  //       if (response.data && response?.data?.data?.LeadCandidateStatus) {
  //         const leadCandidateStatus = response?.data?.data?.LeadCandidateStatus;
  //         const selectedStatus = leadData.LeadCandidateStatus_189;          
  //         setLeadCandidateStatus(leadCandidateStatus);
  //         setSelectedStatus(selectedStatus);
  //       } else {
  //         console.warn("LeadCandidateStatus not found in response data");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // }
  
  
  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };
  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <form>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12 mt-2">
                  <div className="card">
                    <div class="card-header">
                      <h5>Job & Personal Details</h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-3">
                          <dl>
                            <dt>Job Title</dt>
                            <dd>{leadData.job_title}</dd>
                          </dl>
                        </div>
                        <div className="col-md-3">
                          <dl>
                            <dt>Applied Date</dt>
                            <dd>
                              {moment(leadData.AppliedDate).format(
                                "DD-MMM-YYYY"
                              )}
                            </dd>
                          </dl>
                        </div>
                        <div className="col-md-3">
                          <dl>
                            <dt>First Name</dt>
                            <dd>{leadData.FirstName}</dd>
                          </dl>
                        </div>
                        <div className="col-md-3">
                          <dl>
                            <dt>Last Name</dt>
                            <dd>{leadData.LastName}</dd>
                          </dl>
                        </div>
                      </div>

                      <div className="row">
                      <div className="col-sm-3">
                        <dl>
                          <dt>DOB</dt>
                          <dd>
                            {moment(leadData.DateOfBirth).format("DD-MMM-YYYY")}
                          </dd>
                        </dl>
                      </div>
                      <div className="col-sm-3">
                        <dl>
                          <dt>Mobile #1</dt>
                          <dd>
                            {leadData.MobileNo}
                          </dd>
                        </dl>
                      </div>
                      <div className="col-sm-3">
                        <dl>
                          <dt>Mobile #2</dt>
                          <dd>
                            {leadData.MobileNo1}
                          </dd>
                        </dl>
                      </div>
                      <div className="col-sm-3">
                        <dl>
                          <dt>Email ID</dt>
                          <dd>
                            {leadData.EmailID}
                          </dd>
                        </dl>
                      </div>
                      </div>
                      <div className="row">
                      <div className="col-sm-4">
                        <div class="">
                          <RatingComponentWithoutNa
                            label="Intro Yourself"
                            name="IntroduceYourself"
                            value={leadData.IntroduceYourself}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div class="">
                          <RatingComponentWithoutNa
                            label="Oral Skills"
                            name="OralSkills"
                            value={leadData.OralSkills}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div class="">
                          <RatingComponentWithoutNa
                            label="Accent"
                            name="Accent"
                            value={leadData.Accent}
                          />
                        </div>
                      </div>
                      </div>
              
                    </div>
                  </div>
                </div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="card">
                    <div class="card-header">
                      <h5 class="subheading">Company & Project Details</h5>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-3">
                          <dl>
                            <dt>Company Name</dt>
                            <dd>
                              {leadData.CurrentCompanyName}
                            </dd>
                          </dl>
                        </div>
                        <div class="col-sm-3">
                          <dl>
                            <dt>Designation</dt>
                            <dd>
                              {leadData.CurrentPosition}
                            </dd>
                          </dl>
                        </div>
                        <div class="col-sm-3">
                          <dl>
                            <dt>Exp. in yrs</dt>
                            <dd>
                              {leadData.CurrentExperienceInYears}
                            </dd>
                          </dl>
                        </div>
                        <div class="col-sm-3">
                          <dl>
                            <dt>Rel.Exp Yrs</dt>
                            <dd>
                              {leadData.CurrentRelevantExperienceInYears}
                            </dd>
                          </dl>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-sm-3">
                          <dl>
                            <dt>Qualifications</dt>
                            <dd>
                              {leadData.Qualifications}
                            </dd>
                          </dl>
                        </div>

                        <div class="col-sm-3">
                          <dl>
                            <dt>Notice Period</dt>
                            <dd>
                              {leadData.NoticePeriod}
                            </dd>
                          </dl>
                        </div>
                        <div class="col-sm-3">
                          <dl>
                            <dt>CTC (LPA)</dt>
                            <dd>
                              {leadData.CurrentCTC}{" "}
                            </dd>
                          </dl>
                        </div>
                        <div class="col-sm-3">
                          <dl>
                            <dt>
                              ECTC (LPA)
                            </dt>
                            <dd>
                              {leadData.ExpectedCTC}{" "}
                            </dd>
                          </dl>
                        </div>
                       </div>

                       <div class="row">
                      <div class="col-md-12 col-sm-12">
                        <Form.Group className="col-form-label">
                          <Form.Label>
                            1.Work Details
                          </Form.Label>
                          <p>
                          <HTMLComponent html={leadData.ProjectOtherDesc ? leadData.ProjectOtherDesc : "NA"} />
                          </p>
                        </Form.Group>
                      </div>
                    
                   
                    </div>
                  </div>
                </div>
                </div>

              {/* =================== */}
              <div className="col-md-12 flex-col mt-2">
                <div class="card">
                  <div class="card-header">
                    <h5 className="subheading">Rating</h5>
                  </div>
                  <div className="card-body">
                    <div className="row justify-content-center">
                      <div className="col-md-6 d-flex flex-column align-items-center">
                          <RatingComponent
                            label="Dashboard Development"
                            name="AreaDashboard"
                            value={leadData.AreaDashboard}
                          />
                       
                        <div className="mt-2">
                          <RatingComponent
                            label="Architecture"
                            name="AreaArchitecture"
                            value={leadData.AreaArchitecture}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 d-flex flex-column align-items-center">
                       
                          <RatingComponent
                            label="SDK"
                            name="AreaSDK"
                            value={leadData.AreaSDK}
                          />
               
                        <div className="mt-2">
                          <RatingComponent
                            label="Report Development"
                            name="AreaReport"
                            value={leadData.AreaReport}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row justify-content-center mt-2">
                      <div className="col-md-6 d-flex justify-content-center">
                        <RatingComponent
                          label="Administration"
                          name="AreaAdministration"
                          value={leadData.AreaAdministration}
                        />
                      </div>
                      <div className="col-md-6 d-flex justify-content-center">
                        <RatingComponent
                          label="Other Skills"
                          name="AreaOtherSkill"
                          value={leadData.AreaOtherSkill}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ==================== */}
              <div className="col-md-12 flex-col mt-2 mb-2">
                <div className="card">
                  <div className="card-header">
                    <h5 className="subheading">Other Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group d-flex flex-column">
                          <label
                            htmlFor="WillingToTravel"
                            className="form-label"
                          >
                            Willing To Travel
                          </label>
                          <div className="d-flex gap-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="WillingToTravel"
                                id="Yes"
                                value="Yes"
                                checked={
                                  leadData.WillingToTravel == "Yes"
                                    ? true
                                    : false
                                }
                              />
                              <label className="form-check-label" htmlFor="Yes">
                                Yes
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="WillingToTravel"
                                id="no"
                                value="No"
                                checked={
                                  leadData.WillingToTravel == "No"
                                    ? true
                                    : false
                                }
                              />
                              <label className="form-check-label" htmlFor="no">
                                No
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="WillingToTravel"
                                id="occasionally"
                                value="Occasionally"
                                checked={
                                  leadData.WillingToTravel == "Occasionally"
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="occasionally"
                              >
                                Occasionally
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <dl>
                          <dt>Current Location</dt>
                          <dd>
                            {leadData.CurrentLocation}
                          </dd>
                        </dl>
                      </div>
                      <div className="col-sm-4">
                        <dl>
                          <dt>
                            Preferred Location
                          </dt>
                          <dd>
                            {leadData.PreferredLocation}
                          </dd>
                        </dl>
                      </div>
                      </div>

                      <div className="row">
                      <div className="col-sm-4">
                        <dl>
                          <dt>
                            Reason For Change
                          </dt>
                          <dd>
                            {leadData.ReasonForChange}
                          </dd>
                        </dl>
                      </div>
                      <div className="col-sm-4">
                        <dl>
                          <dt>Source</dt>
                          <DropdownValue
                            name="CandidateReferralType_174"
                            url={API_URL + "fetch-referral-type"}
                            value={leadData.CandidateReferralType_174}
                          />
                        </dl>
                      </div>
                      <div className="col-sm-4">
                        <dl>
                          <dt>Note</dt>
                          <dd>
                            {leadData.ReferralNote}
                          </dd>
                        </dl>
                      </div>
                      </div>
                   
                  
                  </div>

                  <div className="col-sm-12 d-flex justify-content-center">
                    <div>
                      <div className="col-sm-12 d-flex justify-content-center mt-4">
                        <label
                          htmlFor="LeadCandidateStatus_189"
                          className="form-label me-4"
                        >
                          Status:
                        </label>
                        {leadCandidateStatus.map((status) => (
                          <div
                            key={status.value}
                            className="form-check form-check-inline"
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="status"
                              value={status.value}
                              checked={selectedStatus === status.value}
                              // onChange={handleStatusChange}
                              // onChange={() => {}} 
                            />
                            <label
                              className="form-check-label"
                              htmlFor={status.text}
                            >
                              {status.text}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LeadCreated;
